import { useEffect } from "react";
import { Property } from "../../global/types";
import {
  buildPropertySearchDescription,
  buildPropertySearchTitle,
  replacePrimarySeoTags,
} from "../../seo/propertyPageSeo";

const UNAVAILABLE_TITLE = "Imóvel não encontrado";
const UNAVAILABLE_DESCRIPTION = "Este imóvel não está disponível na 7Cantos.";

interface PropertySeoTagsProps {
  property?: Property | null;
  pageUrl: string;
  imageUrl?: string;
  unavailable: boolean;
}

export default function PropertySeoTags({
  property,
  pageUrl,
  imageUrl,
  unavailable,
}: PropertySeoTagsProps) {
  useEffect(() => {
    if (unavailable) {
      replacePrimarySeoTags(document, {
        title: UNAVAILABLE_TITLE,
        description: UNAVAILABLE_DESCRIPTION,
        canonicalUrl: pageUrl,
      });
      return;
    }

    if (!property?.title) {
      return;
    }

    replacePrimarySeoTags(document, {
      title: buildPropertySearchTitle(property),
      description: buildPropertySearchDescription(property),
      canonicalUrl: pageUrl,
      imageUrl,
      imageAlt: property.title,
    });
  }, [property, pageUrl, imageUrl, unavailable]);

  return null;
}
